export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0,
    expeditionId: 1,
    receptionId: 2
  },
  actions: {
    async list ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/' + params.path, params: params.filters }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/listes.js